import { useEffect, useRef, useState } from "react";
import ModalBasicLayout from "../Modal/ModalBasicLayout";
import Loader from "../Loaders/Loader";
import { SimpleAlert } from "../Alerts/Alerts";
import { useTranslationApp } from "../../lib/i18next";
import { useDispatchApp } from "../../lib/redux";
import { startGetLeadFormByID } from "../../actions/adsCampaigns";
import { getLeadFormViewValues } from "../../utils/linkedInLeadFormLanguage";
import {
  LOADING_INFORMATION,
  MODAL_VIEW_LEAD_FORM_LOAD_ERROR,
  MODAL_VIEW_LEAD_FORM_TITLE,
} from "../../i18n/keysTranslations";
import ModalCreateLeadForm from "./ModalCreateLeadForm";

const ModalViewLeadForm = ({
  modalOpen = false,
  onCloseModal = () => {},
  onCallbackSave = () => {},
  leadForm,
  integrationID,
  adAccountID,
  campaignLanguage = "en",
}) => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const [loadedLeadForm, setLoadedLeadForm] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const onCloseModalRef = useRef(onCloseModal);
  onCloseModalRef.current = onCloseModal;

  useEffect(() => {
    if (!modalOpen) return undefined;

    let isActive = true;

    const onLoadLeadForm = async () => {
      try {
        const response = await dispatch(
          startGetLeadFormByID({
            integrationID,
            adAccountID,
            leadFormID: leadForm?.id,
            shouldContinue: () => isActive,
          })
        );

        if (!isActive || response?.code === "aborted") return;

        if (!response?.ok || !response?.data) {
          SimpleAlert({
            icon: "error",
            text: t(MODAL_VIEW_LEAD_FORM_LOAD_ERROR),
          });
          onCloseModalRef.current();
          return;
        }

        setLoadedLeadForm(response.data);
        setIsLoading(false);
      } catch {
        if (!isActive) return;
        SimpleAlert({
          icon: "error",
          text: t(MODAL_VIEW_LEAD_FORM_LOAD_ERROR),
        });
        onCloseModalRef.current();
      }
    };

    onLoadLeadForm();

    return () => {
      isActive = false;
    };
  }, [adAccountID, dispatch, integrationID, leadForm?.id, modalOpen, t]);

  if (!isLoading && loadedLeadForm) {
    return (
      <ModalCreateLeadForm
        key={`view-${leadForm?.id}`}
        modalOpen={modalOpen}
        readOnly
        initialValues={getLeadFormViewValues({
          leadForm: loadedLeadForm,
          campaignLanguage,
        })}
        integrationID={integrationID}
        adAccountID={adAccountID}
        campaignLanguage={campaignLanguage}
        onCloseModal={onCloseModal}
        onCallbackSave={onCallbackSave}
      />
    );
  }

  // The read-only form modal replaces this loader and owns the history entry.
  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth
      scroll="paper"
      maxWidth="sm"
      title={t(MODAL_VIEW_LEAD_FORM_TITLE)}
      enableHistoryManagement={false}
    >
      <Loader hasMessage message={t(LOADING_INFORMATION)} />
    </ModalBasicLayout>
  );
};

export default ModalViewLeadForm;
